<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <template>
          <h1 class="title">{{ modalTitle }}</h1>
        </template>
      </div>

      <RichTextEditor :headings="[]" v-model="description" />

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button
          v-if="isEditMode"
          label="Delete"
          @click="onDelete"
          type="is-danger"
          outlined
        />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
import RichTextEditor from '../../RichTextEditor';

export default {
  name: 'WIStepModal',

  props: {
    initialData: {
      type: Object,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    RichTextEditor,
  },

  data() {
    return {
      description: '',
    };
  },

  computed: {
    modalTitle() {
      return this.isEditMode
        ? 'Edit Work Instruction Step'
        : 'Create Work Instruction Step';
    },
  },

  watch: {
    initialData: {
      immediate: true,
      handler(newVal) {
        this.description = newVal?.description || '';
      },
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onSave() {
      this.$emit('save', { description: this.description });
    },
    onDelete() {
      this.$emit('onDelete');
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
